import React from 'react';
import { Helmet } from 'react-helmet-async';
import SEO_PAGES from '../lib/seo-pages.json';

const SITE = 'https://simplif-i.com';

// Head tags for public pages outside MarketingLayout, from the shared SEO source.
export const SeoHead = ({ path }) => {
  const seo = SEO_PAGES[path];
  if (!seo) return null;
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <link rel="canonical" href={url} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={`${SITE}/og-image.png`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
    </Helmet>
  );
};
